import { ff } from '@atlassian/jira-feature-flagging';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default {
	get(): boolean {
		return ff('nin-priority-inline-edit');
	},
};
